import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import Filter from 'views/customers/players/filter'; // Importing Filter component
import Table from 'views/customers/players/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PlayersListView class extends JetView to create a view for player listings.
 */
export default class PlayersListView extends JetView {
    /**
     * Configures the layout of the PlayersListView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        var vthis = this; // Reference to the current instance

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger change size event
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    animate: {
                        subtype: 'out',
                    },
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to data table
                                var originalTemplate = null;
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].id == 'RiskStatus') {
                                        if (!originalTemplate) {
                                            originalTemplate = table.config.columns[j].template;
                                        }

                                        table.config.columns[j].template = function (obj) {
                                            // Custom template for RiskStatus column
                                            if (obj.RiskStatus == 'A') {
                                                return 'Alto';
                                            } else if (obj.RiskStatus == 'M') {
                                                return 'Medio';
                                            } else if (obj.RiskStatus == 'B') {
                                                return 'Bajo';
                                            } else if (obj.RiskStatus == 'NC') {
                                               return 'No clasificado'
                                            }   else {
                                                return '';
                                            }
                                        };
                                    }
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + 'Jugadores',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Jugadores',
                                    ignore: {
                                        detailTittle: true,
                                        Action: true,
                                    },
                                }).then(() => {

                                    // Restaurar template original
                                    for (var j = 0; j < table.config.columns.length; j++) {
                                        if (table.config.columns[j].id == 'RiskStatus' && originalTemplate) {
                                            table.config.columns[j].template = originalTemplate;
                                        }
                                    }

                                    table.refreshColumns(); // importante para que vuelva a pintar
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    var table = $$('datatable'); // Reference to data table
                                    var originalTemplate = null;
                                    for (var j = 0; j < table.config.columns.length; j++) {
                                        if (table.config.columns[j].id == 'RiskStatus') {
                                            if (!originalTemplate) {
                                                originalTemplate = table.config.columns[j].template;
                                            }

                                            table.config.columns[j].template = function (obj) {
                                                // Custom template for RiskStatus column
                                                if (obj.RiskStatus == 'A') {
                                                    return 'Alto';
                                                } else if (obj.RiskStatus == 'M') {
                                                    return 'Medio';
                                                } else if (obj.RiskStatus == 'B') {
                                                    return 'Bajo';
                                                } else if (obj.RiskStatus == 'NC') {
                                                    return 'No clasificado'
                                                }   else {
                                                    return '';
                                                }
                                            };
                                        }
                                        if (table.config.columns[j].exportType) {
                                            delete table.config.columns[j].format; // Remove format for export
                                        }
                                    }
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + 'Jugadores',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Jugadores',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Action: true,
                                        },
                                    }).then(() => {

                                        // Restaurar template original
                                        for (var j = 0; j < table.config.columns.length; j++) {
                                            if (table.config.columns[j].id == 'RiskStatus' && originalTemplate) {
                                                table.config.columns[j].template = originalTemplate;
                                            }
                                        }

                                        table.refreshColumns(); // importante para que vuelva a pintar
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for player list
                    css: theme,
                    elements: [
                        {
                            view: 'label',
                            align: 'center',
                            label: _('Lista de Jugadores'), // Label for player list
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main form view
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left panel
                },
            ],
        };
    }

    /**
     * Initializes the PlayersListView.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Adjust layout for small screens
                var childs = $$('toolbar').getChildViews();
                $$('toolbar').removeView(childs[2]); // Remove export button
                $$('pagerA').define('group', 1); // Group pager items
            }
            webix.attachEvent('onRotate', function (orientation) {
                // Reload on orientation change
                window.location.reload();
            });
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
